import { render, staticRenderFns } from "./newslist.vue?vue&type=template&id=89ed50fa"
import script from "./newslist.vue?vue&type=script&lang=js"
export * from "./newslist.vue?vue&type=script&lang=js"
import style0 from "./newslist.vue?vue&type=style&index=0&id=89ed50fa&lang=css"
import style1 from "./newslist.vue?vue&type=style&index=1&id=89ed50fa&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89ed50fa')) {
      api.createRecord('89ed50fa', component.options)
    } else {
      api.reload('89ed50fa', component.options)
    }
    module.hot.accept("./newslist.vue?vue&type=template&id=89ed50fa", function () {
      api.rerender('89ed50fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/newslist.vue"
export default component.exports